import { render, staticRenderFns } from "./SimpleEntitySearch.vue?vue&type=template&id=bba821ee&scoped=true&lang=pug"
import script from "./SimpleEntitySearch.vue?vue&type=script&lang=js"
export * from "./SimpleEntitySearch.vue?vue&type=script&lang=js"
import style0 from "./SimpleEntitySearch.vue?vue&type=style&index=0&id=bba821ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba821ee",
  null
  
)

export default component.exports